import { ROUTESWEB } from "@repo/utils";
import type { DeeplinkModule, ModuleHandler, DeeplinkRoute } from "../types";
import { selfLearnHandler } from "./selfLearn";
import { liveClassHandler } from "./liveClass";
import { testsHandler } from "./tests";

/**
 * Registry of module handlers.
 * Add new modules here to keep DeepLinkHandler.tsx clean.
 */
export const MODULE_HANDLERS: Partial<Record<DeeplinkModule, ModuleHandler>> = {
  selflearn: selfLearnHandler,
  liveclass: liveClassHandler,
  doubts: (): DeeplinkRoute => ({
    path: `/${ROUTESWEB.APP.DOUBTS}`,
  }),

  subscriptions: (parsed): DeeplinkRoute => {
    const type = parsed.type?.toLowerCase();
    if (type === "programbatch-allocation") {
      return { path: `/${ROUTESWEB.APP.SMART_BATCHING}` };
    }
    const params = new URLSearchParams(parsed.allParams);
    params.delete("module");
    params.delete("isFromDeepLinking");
    
    const queryString = params.toString();
    return {
      path: `/${ROUTESWEB.APP.SUBSCRIPTIONS}${queryString ? `?${queryString}` : ""}`,
    };
  },

  contactUs: (): DeeplinkRoute => ({
    path: `/${ROUTESWEB.APP.CONTACT_US}`,
  }),

  bookmarks: (): DeeplinkRoute => ({
    path: `/${ROUTESWEB.APP.BOOKMARKS}`,
  }),

  refer: (): DeeplinkRoute => ({
    path: `/${ROUTESWEB.APP.REFER_AND_EARN}`,
  }),

  orders: (parsed): DeeplinkRoute => {
    const params = new URLSearchParams(parsed.allParams);
    params.delete("module");
    params.delete("isFromDeepLinking");
    return {
      path: `/${ROUTESWEB.APP.REVIEW_ORDER}?${params.toString()}`,
    };
  },
  tests: testsHandler,
};
